<!-- Базовый текст - Atom -->
<template>
  <component
    :is="tag"
    :class="[
      'font-primary',
      sizeClasses,
      colorClasses,
      weightClasses,
      alignClasses,
      leadingClasses
    ]"
  >
    <slot />
  </component>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  /** HTML тег */
  tag?: 'p' | 'span' | 'div' | 'small' | 'strong' | 'em'
  /** Размер текста */
  size?: 'xs' | 'sm' | 'base' | 'lg' | 'xl'
  /** Цвет текста */
  color?: 'default' | 'primary' | 'muted' | 'white' | 'black'
  /** Толщина шрифта */
  weight?: 'normal' | 'medium' | 'semibold' | 'bold'
  /** Выравнивание */
  align?: 'left' | 'center' | 'right'
  /** Межстрочный интервал */
  leading?: 'none' | 'tight' | 'normal' | 'relaxed'
}

const props = withDefaults(defineProps<Props>(), {
  tag: 'p',
  size: 'base',
  color: 'default',
  weight: 'normal',
  align: 'left',
  leading: 'normal'
})

// Классы размеров
const sizeClasses = computed(() => {
  switch (props.size) {
    case 'xs':
      return 'text-xs'
    case 'sm':
      return 'text-sm'
    case 'lg':
      return 'text-lg'
    case 'xl':
      return 'text-xl'
    default:
      return 'text-base'
  }
})

// Классы цветов (из дизайна Figma)
const colorClasses = computed(() => {
  switch (props.color) {
    case 'primary':
      return 'text-primary'
    case 'muted':
      return 'text-muted'
    case 'white':
      return 'text-white'
    case 'black':
      return 'text-black'
    default:
      return 'text-foreground'
  }
})

// Классы толщины шрифта
const weightClasses = computed(() => {
  switch (props.weight) {
    case 'medium':
      return 'font-medium'
    case 'semibold':
      return 'font-semibold'
    case 'bold':
      return 'font-bold'
    default:
      return 'font-normal'
  }
})

// Классы выравнивания
const alignClasses = computed(() => {
  switch (props.align) {
    case 'center':
      return 'text-center'
    case 'right':
      return 'text-right'
    default:
      return 'text-left'
  }
})

// Классы межстрочного интервала
const leadingClasses = computed(() => {
  switch (props.leading) {
    case 'none':
      return 'leading-none'
    case 'tight':
      return 'leading-tight'
    case 'relaxed':
      return 'leading-relaxed'
    default:
      return 'leading-normal'
  }
})
</script>








